import { useEffect } from 'react';
import { Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { useOnceReveal } from '@common/hooks';
import { useUBL } from '@common/log-manager';

export interface SizeInfoListProps {
  catalogProductId: string;
  itemList: Array<SizeInfoItem>;
  renderItem: (item: SizeInfoItem, index: number) => React.ReactNode;
}

export type SizeInfoItem = {
  imageUrl: string;
  valueList: string[][];
  description: string[];
};

export function SizeInfoList({ catalogProductId, itemList, renderItem }: SizeInfoListProps) {
  const { targetRef, isRevealed } = useOnceReveal();
  const sendUBL = useUBL();

  useEffect(() => {
    if (isRevealed) {
      sendUBL({
        category: 'impression',
        navigation: 'product_detail',
        object_section: 'measurements',
        data: { catalog_product_id: catalogProductId },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRevealed]);

  return (
    <Wrapper ref={targetRef}>
      <Text variant='Body_18_SemiBold' color='textPrimary' style={{ marginBottom: '12px' }}>
        실측 사이즈
      </Text>
      {itemList.map(renderItem)}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
`;
